import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, mergeProps as _mergeProps, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "label"
}
const _hoisted_2 = {
  key: 0,
  class: "tooltip"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_info_button = _resolveComponent("info-button")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.label && !_ctx.editing || _ctx.disableEditing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.tooltip)
            ? _renderSlot(_ctx.$slots, "tooltip", { key: 0 }, () => [
                (_ctx.tooltip)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createVNode(_component_info_button),
                      _createVNode(_component_q_tooltip, {
                        anchor: "bottom left",
                        "max-width": "200px"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "text-center tooltip-text",
                            innerHTML: _ctx.tooltip
                          }, null, 8, _hoisted_3)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ], true)
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "label", { inputState: _ctx.inputState }, () => [
            _createElementVNode("label", {
              class: _normalizeClass({ error: _ctx.error, warn: _ctx.warn })
            }, _toDisplayString(_ctx.label), 3)
          ], true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["value", { 'static': !_ctx.editing || _ctx.disableEditing, editing: _ctx.editing && !_ctx.disableEditing, 'contains-tooltip': !!_ctx.tooltip }])
    }, [
      (_ctx.readonly || !_ctx.editing || _ctx.disableEditing)
        ? _renderSlot(_ctx.$slots, "static", {
            key: 0,
            inputState: _ctx.inputState
          }, () => [
            (_ctx.inputState.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.inputState.value), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, "-"))
          ], true)
        : _createCommentVNode("", true),
      (_ctx.editing && !_ctx.disableEditing)
        ? _renderSlot(_ctx.$slots, "input", {
            key: 1,
            inputState: _ctx.inputState
          }, () => [
            _createVNode(_component_q_input, _mergeProps({
              label: _ctx.inputState.label,
              outlined: "",
              clearable: "",
              counter: "",
              dense: "",
              maxlength: _ctx.max,
              modelValue: _ctx.inputState.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputState.value) = $event))
            }, _ctx.inputAttrs, { type: _ctx.type }), null, 16, ["label", "maxlength", "modelValue", "type"])
          ], true)
        : _createCommentVNode("", true)
    ], 2)
  ], 64))
}